import { render, staticRenderFns } from "./RequestChatBlock.vue?vue&type=template&id=9ee04042&"
import script from "./RequestChatBlock.vue?vue&type=script&lang=js&"
export * from "./RequestChatBlock.vue?vue&type=script&lang=js&"
import style0 from "./RequestChatBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequestChatBlock.vue"
export default component.exports